import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { useWizard } from "react-use-wizard";
import AnimatedTextInput from "../../components/animatedTextInput";
import React, { useEffect, useState } from "react";
import MultipleChoiceWithoutSubmit from "../../components/multipleChoiceWithoutSubmit";
import { useTranslation } from "react-i18next";

//TODO: Generalise name, since it is reusable
function MedicalConditionsPart2Step({
  initState = null,
  onSubmitHandler,
  qKey,
  question,
  questionCode,
  choices,
  noneOptionText,
  otherChoiceCode,
  noneChoiceCode,
  hideLibrary = false,
}) {
  const { previousStep, nextStep } = useWizard();
  const [selectedChoices, setSelectedChoices] = useState(
    initState ? initState["choiceSelection"] : {}
  );
  const [isOtherOptionSelected, setIsOtherOptionSelected] = useState(
    initState ? initState["isOtherOptionSelectedInit"] : false
  );
  const [otherOptionValue, setOtherOptionValue] = useState(
    initState ? initState["otherOptionValueInit"] : ""
  );
  const [isNoneApplicable, setNoneApplicable] = useState(
    initState ? initState["isNoneApplicableInit"] : false
  );
  const { t } = useTranslation();

  const toggleOtherOption = (e) => {
    setIsOtherOptionSelected(!isOtherOptionSelected);
  };

  const toggleNoneApplicableOption = (e) => {
    setNoneApplicable(!isNoneApplicable);
  };

  useEffect(() => {
    if (!isOtherOptionSelected) {
      setOtherOptionValue("");
    } else {
      setNoneApplicable(false);
    }
  }, [isOtherOptionSelected]);

  useEffect(() => {
    if (isNoneApplicable) {
      setOtherOptionValue("");
      setIsOtherOptionSelected(false);
      setSelectedChoices({});
    }
  }, [isNoneApplicable]);

  useEffect(() => {
    Object.keys(selectedChoices).forEach((key) => {
      if (selectedChoices[key]["checked"]) {
        setNoneApplicable(false);
        return;
      }
    });
  }, [selectedChoices]);

  const updateChoices = (data) => {
    setSelectedChoices(data);
  };

  const updateOtherOptionText = (e) => {
    setOtherOptionValue(e.target.value);
  };

  const next = () => {
    let _choices = Object.keys(selectedChoices).map((key) => ({
      text: selectedChoices[key]["value"],
      correct: selectedChoices[key]["checked"],
      code: selectedChoices[key]["id"],
    }));

    if (isOtherOptionSelected) {
      _choices.push({
        text: otherOptionValue,
        correct: true,
        code: otherChoiceCode,
      });
    }

    if (isNoneApplicable) {
      _choices.push({
        text: "None of the above",
        correct: true,
        code: noneChoiceCode,
      });
    }

    const response = {
      _state: {
        choiceSelection: selectedChoices,
        isOtherOptionSelectedInit: isOtherOptionSelected,
        isNoneApplicableInit: isNoneApplicable,
        otherOptionValueInit: otherOptionValue,
      },
      formatted_response: [
        {
          type: "MULTI",
          question: question,
          code: questionCode,
          choices: _choices,
        },
      ],
    };
    onSubmitHandler({ [qKey]: response });
    nextStep();
  };

  const canSubmit = () => {
    if (isNoneApplicable) return true;
    let isOptionSet = false;
    Object.keys(selectedChoices).forEach((key) => {
      if (selectedChoices[key]["checked"]) {
        isOptionSet = true;
        return;
      }
    });
    return isOptionSet || (isOtherOptionSelected && otherOptionValue !== "");
  };

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={previousStep}
        title={t("hi.title")}
        hideLibrary={hideLibrary}
      />
      <div className="body_content">
        <div className="inner_body">
          <MultipleChoiceWithoutSubmit
            question={question}
            choices={choices}
            qKey={qKey}
            selectedChoices={selectedChoices}
            onChange={updateChoices}
          />
          <ul className="list-unstyled list_checkbox_btn">
            <li>
              <label>
                <input
                  type="checkbox"
                  key="otherOption"
                  value={otherOptionValue}
                  id={otherChoiceCode}
                  checked={isOtherOptionSelected}
                  onChange={toggleOtherOption}
                />
                <span className="dot"></span>
                <span className="txt">{t("hi.other")}</span>
              </label>
            </li>
          </ul>
          <div className="fill_form light_fill_form">
            <div className="field_group">
              <span className="txt_lbl">
                {t("hi.otherText")} <sup>*</sup>
              </span>
              <AnimatedTextInput
                value={otherOptionValue}
                onChange={updateOtherOptionText}
                id="otherOptionText"
                isDisabled={!isOtherOptionSelected}
              />
            </div>
          </div>
          <ul className="list-unstyled list_checkbox_btn">
            <li>
              <label>
                <input
                  type="checkbox"
                  key="noneOption"
                  id={noneChoiceCode}
                  checked={isNoneApplicable}
                  onChange={toggleNoneApplicableOption}
                />
                <span className="dot"></span>
                <span className="txt">{noneOptionText}</span>
              </label>
            </li>
          </ul>
        </div>
        <div className="btn_block bottom_button d-flex justify-content-center">
          <button
            className="btn btn_primary nextstep_cta"
            disabled={!canSubmit()}
            onClick={() => next()}
          >
            {t("login.DOBSTEP.button")}
          </button>
        </div>
      </div>
    </>
  );
}

export default MedicalConditionsPart2Step;
